/* istanbul ignore file */
import { odata } from '@bingads-webui/http-util';
import _ from 'underscore';
import { AzureUploader, FilePayload } from '@bingads-webui/azure-upload';

export class VideoResourceRepository {
  constructor(
    cid,
    aid,
    oDataConfig,
    activityLogger
  ) {
    this.cid = cid;
    this.aid = aid;
    this.baseURL = `${oDataConfig.odataPath}/Customers(${this.cid})/Accounts(${this.aid})/`;
    this.oDataConfig = {
      oDataToken: oDataConfig.odataToken,
      oDataTokenType: oDataConfig.oDataTokenType,
      applicationName: oDataConfig.applicationName,
    };
    this.uploader = new AzureUploader({
      logger: activityLogger ? {
        trace: activityLogger.signal,
        error: activityLogger.error,
      } : {
        trace: _.noop,
        error: _.noop,
      },
    });
  }

  getResourceUploadUrl({ fileExtension, resourceType, videoId }) {
    const url = `${this.baseURL}Videos/${videoId}/Resources/Default.GetUploadUrl(resourceType=Enum.VideoResourceType'${resourceType}',fileExtension='${fileExtension}')`;
    return odata.get(url, this.oDataConfig);
  }

  getResources({ videoId }) {
    const url = `${this.baseURL}Videos/${videoId}/Resources`;
    return odata.get(url, this.oDataConfig);
  }

  createResourceFromBlob({
    videoId,
    blobName,
    type,
    odataType,
    resourceParamters,
  }) {
    const url = `${this.baseURL}Videos/${videoId}/Resources`;
    return odata.post(url, {
      ...this.oDataConfig,
      urlParameters: { blobName },
      data: {
        '@odata.type': odataType,
        Type: type,
        ...resourceParamters,
      },
    });
  }

  createResource({
    videoId,
    file,
    fileExtension,
    onProgress,
    odataType,
    resourceType,
    resourceParamters,
  }) {
    return this.getResourceUploadUrl({ fileExtension, resourceType, videoId })
      .then((blob) => {
        const { BlobName: blobName } = blob;
        return this.uploader.uploadPayloadToBlob({
          blob,
          payload: new FilePayload({ file }),
          onProgress,
        })
          .then(() => this.createResourceFromBlob({
            videoId,
            blobName,
            type: resourceType,
            odataType,
            resourceParamters,
          }));
      });
  }

  deleteResource({ videoId, resourceId }) {
    const url = `${this.baseURL}Videos/${videoId}/Resources('${resourceId}')`;
    return odata.delete(url, this.oDataConfig);
  }
}
